import { api } from '@/lib/api';

/**
 * V4.9.5 — "My Tags" inbox API.
 *
 * One row per @-mention: who tagged you, on which ticket, when, and
 * whether you've read it yet.
 */

export interface MentionRow {
  id: string;
  ticket_id: string;
  ticket_category: string | null;
  ticket_status: string | null;
  ticket_summary: string | null;
  mentioned_by: { id: string; alias: string; name: string } | null;
  excerpt: string;
  created_at: string;
  read_at: string | null;
}

export const mentionsApi = {
  list: (unreadOnly = false) =>
    api.get<MentionRow[]>(`/me/tags${unreadOnly ? '?unread=true' : ''}`),
  unreadCount: () => api.get<{ count: number }>('/me/tags/unread-count'),
  markRead: (id: string) => api.patch<{ success: true }>(`/me/tags/${id}/read`, {}),
  markAllRead: () => api.patch<{ updated: number }>('/me/tags/read-all', {})
};
